import { formatPrismicData } from '@monofront/business/utils';
import { IRichTextZone, RichTextZoneProps } from './types';

export const mapRichTextZone = ({
  prismicContent,
}: {
  prismicContent: RichTextZoneProps['slice'];
}): IRichTextZone => {
  const { primary } = formatPrismicData(prismicContent as any);

  return {
    content: primary.content,
    sliceType: prismicContent?.slice_type,
    variation: prismicContent?.variation,
  };
};
